// extracted by mini-css-extract-plugin
module.exports = {"cancel":"CancelButton_cancel__150Rh"};